import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-usage-terms',
  templateUrl: './usage-terms.component.html',
  styleUrls: ['./usage-terms.component.scss']
})
export class UsageTermsComponent implements ControlValueAccessor, OnInit {
  @Input() id: string;
  @Input() name: string;
  @Input() mandatory: boolean;
  @Input() termsContent: string;
  @Input() isLoading: boolean;
  public value = false;
  public formGroup: UntypedFormGroup;

  constructor(@Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;
  }

  ngOnInit() {
    this.formGroup = new UntypedFormGroup({
      termo: new UntypedFormControl(false, [Validators.required])
    });
  }

  public onChange: any = () => {
    // Método onChange foi registrado
  };

  public onTouched: any = () => {
    // Método onTouched foi registrado
  };

  public writeValue(value: boolean) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public handleInput(event: any) {
    this.value = event.target.checked ? true : null;
    this.onChange(this.value);
  }
}
